import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { ImportOrderGateway } from 'src/app/application/gateway/ImportOrderGateway';
import { ProfileGateway } from 'src/app/application/gateway/ProfileGateway';
import { GenericOrderDetail, ImportOrderContainerItem, ImportOrderInformation, ImportOrderListItem } from 'src/app/domain/models/ImportOrder';
import { BasicUser } from 'src/app/domain/models/User';
import { Routes } from 'src/app/infrastructure/routes';
import { ImportOrderStatus, OrderUtils } from 'src/app/ui/util/order-utils';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';

@Component({
  selector: 'app-user-import-orders-purchase',
  templateUrl: './user-import-orders-purchase.component.html',
  styleUrls: ['./user-import-orders-purchase.component.css'],
  providers: [ConfirmationService]
})
export class UserImportOrdersPurchaseComponent implements OnInit {
  tabMenuItems: MenuItem[] = []
  activeItem: MenuItem = {}
  orders: ImportOrderContainerItem[] = []
  profile: BasicUser | undefined

  loading: boolean = false

  @Input()
  activeItemIndex = 1

  constructor(private _router: Router,
    private _authService: AuthGateway,
    private _messageService: MessageService,
    private _importOrderService: ImportOrderGateway,
    public translate: TranslateService) {
  }

  ngOnInit(): void {
    let tabMenuItemInProcessLabel = 'In process'
    let tabMenuItemPurchaseLabel = 'Possible purchases'
    let tabMenuItemForwarderOrderLabel = 'Ordenes Forwarder'

    this.profile = this._authService.getUser()

    if(this.profile) {
      switch(this.profile.lang) {
        case 'en':
          tabMenuItemInProcessLabel = 'In process'
          tabMenuItemPurchaseLabel = 'Possible purchases'
          tabMenuItemForwarderOrderLabel = 'Forwarder orders'
          break
        case 'es':
          tabMenuItemInProcessLabel = 'En proceso'
          tabMenuItemPurchaseLabel = 'Posibles compras'
          tabMenuItemForwarderOrderLabel = 'Ordenes Forwarder'
          break
      }
    }

    this.tabMenuItems = [
      { label: tabMenuItemInProcessLabel, command: () =>  this._router.navigate(['/'+Routes.userImportOrdersCurrent]) },
      { label: tabMenuItemPurchaseLabel, command: () =>  this._router.navigate(['/'+Routes.userImportOrdersPurchase]) },
      { label: tabMenuItemForwarderOrderLabel, command: () =>  this._router.navigate(['/'+Routes.userImportOrdersForwarder]) },
    ]
    this.activeItem = this.tabMenuItems[this.activeItemIndex]
    this.loadOrders()
  }

  onActiveItemChange(event: MenuItem) {
    this.activeItem = event;
  }

  loadOrders() {
    this.loading = true
    this._importOrderService.getAllForShoppingCart().subscribe({
      next: (v) => {
        this.orders = v
        this.loading = false
      },
      error: (e) => {
        this.loading = false
        console.log(e)
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.ImportOrder.ManyRetrieveError') });
      },
      complete: () => console.info('Import Order query successfully')
    })
  }

  getOrderTitle(order: ImportOrderListItem): string {
    return OrderUtils.getOrderTitle(order.sequence)
  }

  getPictureUrl(pictureUrl: ImportOrderListItem): string {
    return environment.apiUrl + pictureUrl
  }

  getSpeciesName(detail: GenericOrderDetail): string {
    if(this.profile) {
      switch(this.profile.lang) {
        case 'es':
          return detail.speciesNameEs
        case 'en':
          return detail.speciesNameEn
        default:
          return detail.speciesNameEn
      }
    }
    return ''
  }

  getDurationDate(date: Date | null): string {
    if (date) return moment(date).format('DD-MM-YYYY')
    return ''
  }

  goToOrderDetailPage(orderId: any) {
    this._router.navigate(['/' + Routes.userOrderDetailPage, orderId])
  }

  goToOrders(){
    this._router.navigate([(Routes.purchaseOrdersPage)])
  }

  getIconUrl(iconUrl: string | undefined): string {
    return iconUrl ? iconUrl : ''
  }

}
